import { useState, useEffect } from 'react';
import { getServices } from '../utils/api';
import './ServiceList.css';

const ServiceList = ({ onSelect, onNext, selectedService }) => {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    loadServices();
  }, []);

  const loadServices = async () => {
    try {
      setLoading(true);
      const response = await getServices();
      setServices(response.data.data || []);
      setError(null);
    } catch (err) {
      console.error('Failed to load services:', err);
      setError('Nepodarilo sa načítať služby. Skúste to prosím neskôr.');
    } finally {
      setLoading(false);
    }
  };

  const handleSelect = (service) => {
    onSelect(service);
  };

  if (loading) {
    return (
      <div className="service-list-loading">
        <div className="spinner"></div>
        <p>Načítavam služby...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="alert alert-error">
        {error}
        {/* <button onClick={loadServices} className="btn btn-sm btn-primary mt-3">
          Skúsiť znova
        </button> */}
      </div>
    );
  }

  return (
    <div className="service-list service-list-compact">
      <div className="services-list">
        {services.map((service) => (
          <div
            key={service.id}
            className={`service-row-compact ${selectedService?.id === service.id ? 'selected' : ''}`}
            onClick={() => handleSelect(service)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                handleSelect(service);
              }
            }}
          >
            <div className="service-radio">
              <div className={`radio-circle ${selectedService?.id === service.id ? 'checked' : ''}`}>
                {selectedService?.id === service.id && <div className="radio-dot"></div>}
              </div>
            </div>

            <div className="service-main">
              <h3 className="service-name">{service.nazov}</h3>
              {service.popis && (
                <p className="service-description">{service.popis}</p>
              )}
            </div>

            <div className="service-meta-compact">
              {service.trvanie_minuty && (
                <span className="meta-pill">{service.trvanie_minuty} min</span>
              )}
              {service.cena && (
                <span className="meta-pill">{service.cena} €</span>
              )}
            </div>
          </div>
        ))}
      </div>

      {services.length === 0 && (
        <div className="empty-state">
          <p>Momentálne nie sú k dispozícii žiadne služby.</p>
        </div>
      )}

      {/* Next Button */}
      <div className="service-actions">
        <button
          className="btn btn-primary"
          onClick={onNext}
          disabled={!selectedService}
        >
          Ďalej
        </button>
      </div>
    </div>
  );
};

export default ServiceList;
